import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { animate, keyframes, query, stagger, state, style, transition, trigger } from '@angular/animations';
import * as kf from '@components/keyframes';
import { EventService } from '@app/shared/helpers/services/event.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-fab',
  templateUrl: './fab.component.html',
  styleUrls: ['./fab.component.scss'],
  animations: [
    trigger('SwipeAnimator', [
      transition('* => swipeLeft', animate(1000, keyframes(kf.slideLeftFab))),
      transition('* => swipeRight', animate(1000, keyframes(kf.slideRightFab)))
    ]),
    trigger('fabToggler', [
      state('inactive', style({
        transform: 'rotate(0deg)'
      })),
      state('active', style({
        transform: 'rotate(90deg)'
      })),
      transition('* <=> *', animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('speedDialStagger', [
      transition('* => *', [

        query(':enter', style({opacity: 0}), {optional: true}),

        query(':enter', stagger('40ms',
          [
            animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
              keyframes(
                [
                  style({opacity: 0, transform: 'translateY(10px)'}),
                  style({opacity: 1, transform: 'translateY(0)'}),
                ]
              )
            )
          ]
        ), {optional: true}),

        query(':leave',
          animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
            keyframes([
              style({opacity: 1}),
              style({opacity: 0}),
            ])
          ), {optional: true}
        )

      ])
    ]),

  ]
})
export class FabComponent implements OnInit, OnDestroy {
  @ViewChild('fabControl', {static: false}) fabControl: ElementRef;

  @Input() type = 'add';
  @Input() icon = 'add';
  @Input() disabled = false;

  @Output() clickOnFab = new EventEmitter<any>();
  @Output() clickOnAddFab = new EventEmitter<any>();
  @Output() clickOnChangeFab = new EventEmitter<any>();

  animationState = '';
  isMobile = false;
  innerWidth;
  mobileMaxWidth = 960;
  swipeSubscription$: Subscription;
  fabTogglerState = 'inactive';
  isMenuOpened = false;
  hoveredAdd = false;
  hoveredChangeView = false;

  constructor(private eventService: EventService) {
    this.swipeSubscription$ = eventService.viewPrivacyObservable$.subscribe(data => {
      this.animationState = data;
    });
  }

  ngOnInit() {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    this.isMobile = this.isMobileResolution();
  }

  fabClick() {
    this.clickOnFab.emit();
  }

  fabAddClick() {
    this.clickOnAddFab.emit();
  }
  fabChangeClick() {
    this.clickOnChangeFab.emit();
  }

  isMobileResolution() {
    if (this.innerWidth) {
      return this.innerWidth <= this.mobileMaxWidth;
    } else {
      return window.innerWidth <= this.mobileMaxWidth;
    }
  }

  ngOnDestroy(): void {
    this.swipeSubscription$.unsubscribe();
  }

  resetAnimation() {
    this.animationState = '';
  }

  toggleOnFab() {
    this.fabTogglerState = 'active';
    this.isMenuOpened = true;
  }

  toggleOffFab() {
    this.fabTogglerState = 'inactive';
    this.isMenuOpened = false;
  }

  onMouseEnterAdd() {
    this.hoveredAdd = true;
  }

  onMouseExitAdd() {
    this.hoveredAdd = false;
  }

  onMouseEnterChangeView() {
    this.hoveredChangeView = true;
  }

  onMouseExitChangeView() {
    this.hoveredChangeView = false;
  }
}
